import api from './api';

const fileSetApi = {
  // Get all file sets with optional filters
  getFileSets: async (params = {}) => {
    // console.log('in getFileSets', params)
    return await api.get('/file-sets', params);
  },
  
  // Get a specific file set by ID
  getFileSet: async (fileSetId) => {
    return await api.get(`/file-sets/${fileSetId}`);
  },
  
  // Create a new file set
  createFileSet: async (data) => {
    return await api.post('/file-sets', data);
  },
  
  // Add files to a file set
  addFilesToFileSet: async (fileSetId, fileIds) => {
    return await api.post(`/file-sets/${fileSetId}/files`, { fileIds });
  }
};

export default fileSetApi;